module.exports = __webpack_public_path__ + "static/media/dashboard_icon.8e0ddfba.svg";